<template>
  <v-col cols="12" class="px-md-1">
    <v-expansion-panels flat class="rounded-0">
      <v-expansion-panel class="ev-2 rounded-0">
        <v-expansion-panel-header
          class="py-0 pl-2 pr-4"
          expand-icon="mdi-menu-down"
        >
          <span class="body2-regular">مشخصات بار</span>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="pa-0">
          <div class="border-top mx-1 pr-1 pb-1">
            <div
              v-for="(item, i) in loadDetails"
              :key="i"
              class="center-right pt-3 body2-regular"
            >
              <v-icon x-small class="logistic--text force-color ml-3"
                >mdi-square</v-icon
              >
              <span class="body2-light" v-text="item.name"></span>:
              {{ item.value }}
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
export default {
  name: "LoadDetailPanel",
  props: {
    load: {
      type: Object,
      required: true,
    },
  },
  computed: {
    loadDetails() {
      const type = this.load.load_type;
      const packaging = this.load.package_type;
      const tonnage = this.load.tonnage;
      const dimensions = this.load.dimensions;
      const desc = this.load.description;
      const loadValue =
        Number(this.load.load_value) > 10
          ? Number(this.load.load_value) / 10
          : 0;

      return {
        type: {
          name: "نوع بار",
          value: type,
          icon: "local_shipping",
        },
        packaging: {
          name: "بسته بندی",
          value: packaging,
          icon: "view_in_ar",
        },
        tonnage: {
          name: "تناژ",
          value: tonnage,
          icon: "check_box",
        },
        dimensions: {
          name: "اندازه بار",
          value:
            String(dimensions[0] ? dimensions[0] : "-") +
            " * " +
            String(dimensions[1] ? dimensions[1] : "-") +
            " * " +
            String(dimensions[2] ? dimensions[2] : "-"),
          icon: "check_box",
        },
        loadValue: {
          name: "ارزش محموله",
          value: this.$utils.formatNumber(loadValue) + " تومان",
          icon: "check_box",
        },
        desc: {
          name: "توضیحات",
          value: desc,
          icon: "error_outline",
        },
      };
    },
  },
};
</script>

<style scoped>
.v-expansion-panel-header {
  height: 20px !important;
  max-height: 20px !important;
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.center-right {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
